
global.moment = require('moment');

require("tempusdominus-bootstrap-4")

import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css'

// month / day / year
var datesForDisable = ["01/01/1999 01:00"]

function init() {
	$('.datepicker.birthdate').datetimepicker({
		// Date only
		format: 'L',
		// French
		locale: "fr",
	});
	
	$('#datetimepicker-timeslot').datetimepicker({
    inline: true,
    format: 'L',
    // French
		locale: "fr",
    enabledDates: datesForDisable
  })
}

$(document).ready(
	init()
);

$(document).on("turbolinks:load", function() {
	init()
});
